import React, { useEffect } from 'react';

let toastFn = null;
export function toast(msg, type = 'success') {
  if (toastFn) toastFn(msg, type);
}

export function ToastContainer() {
  const [toasts, setToasts] = React.useState([]);

  useEffect(() => {
    toastFn = (msg, type) => {
      const id = Date.now();
      setToasts(prev => [...prev, { id, msg, type }]);
      setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3000);
    };
    return () => { toastFn = null; };
  }, []);

  if (!toasts.length) return null;
  return (
    <div style={{position:'fixed',top:52,right:16,zIndex:9999,display:'flex',flexDirection:'column',gap:8}}>
      {toasts.map(t => (
        <div key={t.id} style={{
          background: t.type==='error' ? '#e74c3c' : t.type==='warning' ? '#f39c12' : '#27ae60',
          color:'white', padding:'10px 16px', borderRadius:6,
          boxShadow:'0 4px 12px rgba(0,0,0,0.2)', fontSize:13, fontWeight:'bold',
          minWidth:200, maxWidth:350,
          animation:'slideIn 0.2s ease'
        }}>
          {t.type==='error' ? '❌ ' : t.type==='warning' ? '⚠️ ' : '✅ '}{t.msg}
        </div>
      ))}
      <style>{`@keyframes slideIn { from { transform: translateX(100%); opacity:0; } to { transform: translateX(0); opacity:1; } }`}</style>
    </div>
  );
}
